import Vue from 'vue'
import App from './App.vue'
import router from './router'
import remConfig from './public/rem/rem'
import Vuex from 'vuex'
import axios from 'axios'
import uploader from 'vue-easy-uploader'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import lazy from './public/lazy/imgonload'
import VueWechatTitle from 'vue-wechat-title'
import {
  Toast
} from 'vant';
Vue.use(Toast);
Vue.use(VueWechatTitle)
import Vant from 'vant'
import 'vant/lib/index.css';
Vue.use(Vant)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$http= axios
Vue.use(Vuex)
Vue.config.productionTip = false
let store = new Vuex.Store({})
Vue.use(uploader, store)
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
